/**
 * Upload (HTMDOC-2143) e geração (HTMDOC-2144) compartilham a mesma confirmação de sobrescrita,
 * palavra por palavra. As duas histórias especificam o mesmo texto, então ele mora num lugar só.
 */
export const CERTIFICATE_OVERWRITE_TITLE =
  'Este colaborador já possui um certificado salvo. Deseja substituí-lo?';

export const CERTIFICATE_OVERWRITE_DESCRIPTION =
  'O certificado atual será sobrescrito e essa ação não pode ser desfeita.';
